"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SubscriptionTypeFilter model module.
 * @module model/SubscriptionTypeFilter
 * @version 1.1.3-alpha.1
 */
class SubscriptionTypeFilter {
  /**
   * Constructs a new <code>SubscriptionTypeFilter</code>.
   * @alias module:model/SubscriptionTypeFilter
   */
  constructor() {
    SubscriptionTypeFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SubscriptionTypeFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionTypeFilter} obj Optional instance to populate.
   * @return {module:model/SubscriptionTypeFilter} The populated <code>SubscriptionTypeFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionTypeFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('assignedToMediaIds')) {
        obj['assignedToMediaIds'] = _ApiClient.default.convertToType(data['assignedToMediaIds'], ['String']);
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SubscriptionTypeFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubscriptionTypeFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['assignedToMediaIds'])) {
      throw new Error("Expected the field `assignedToMediaIds` to be an array in the JSON data but got " + data['assignedToMediaIds']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
SubscriptionTypeFilter.prototype['id'] = undefined;

/**
 * @member {Array.<String>} assignedToMediaIds
 */
SubscriptionTypeFilter.prototype['assignedToMediaIds'] = undefined;

/**
 * @member {String} q
 */
SubscriptionTypeFilter.prototype['q'] = undefined;
var _default = exports.default = SubscriptionTypeFilter;